



















import Vue from 'vue'
import Presenter, { IPresenter } from './presenter'

import LinkButton from '@/components/shared/atoms/Button/LinkButton'
import List from '@/components/Voice/List'
import Pager from '@/components/shared/molecules/Pager'

export default Vue.extend({
  components: {
    LinkButton,
    List,
    Pager
  },
  computed: {
    presenter(): IPresenter {
      return Presenter({
        voiceRepository: this.$voiceRepository,
        pagerRepository: this.$pagerRepository
      })
    },
    firstOfPage(): number {
      return (this.presenter.page - 1) * this.presenter.size + 1
    },
    lastOfPage(): number {
      const atLast = this.presenter.page * this.presenter.size
      return atLast >= this.presenter.voices.length ? this.presenter.voices.length : atLast
    }
  },
  methods: {
    handlePageChange(page: number) {
      this.$router.push({ path: this.$route.path, query: { page: String(page) } })
    }
  }
})
